import {FormattedMessage, injectIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, AWS_APP_CONFIG_FIELD_TYPES} from "../../Constants";
import Button from "@amzn/meridian/button";
import Tag from "@amzn/meridian/tag";
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";
import Alert from "@amzn/meridian/alert";
import {fetchTemplates} from "../../NetworkUtils";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import {CREATE_FEATURES_BASE_ROUTE} from "../util/RouteConstants";

const AWSAppConfiguration = (props) => {

    const [awsAppConfigTemplate, setAwsAppConfigTemplate] = useState();
    const [accountID, setAccountID] = useState();
    const [applicationName, setApplicationName] = useState();
    const [environmentName, setEnvironmentName] = useState();
    const [configurationProfile,setConfigurationProfile] = useState();
    const [awsRegion, setAwsRegion] = useState();
    const [fieldName, setFieldName] = useState();
    const [fieldType, setFieldType] = useState();
    const [showMcmButton, setShowMcmButton] = useState(false);
    const [fields, setFields] = useState([]);
    const [historyProps, setHistoryProps] = useState([{featureId: "", configId: "", mcmId: ""}]);
    const [awsAppConfigTemplates, setAWSAppConfigTemplates] = useState([]);
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const warningAlert = {visible: true, text: "Create AWS App Config request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully created AWS App Config", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        try {
            setHistoryProps({
                featureId: props.location.state.featureId,
                configId: props.location.state.configId,
                mcmId: props.location.state.mcmId
            });
            setAwsAppConfigTemplate(props.location.state.template);
            setAccountID(props.location.state.accountID);
            setApplicationName(props.location.state.applicationName);
            setEnvironmentName(props.location.state.environmentName);
            setConfigurationProfile(props.location.state.configurationProfile)
            setAwsRegion(props.location.state.awsRegion)
            setFields(props.location.state.fields ? props.location.state.fields : []);
        } catch(error) {}

        fetchTemplates("AWS_APP_CONFIG").then(response => setAWSAppConfigTemplates(response));
    }, []);

    useEffect(() => {
        if (!historyProps || !historyProps.mcmId) {
            setShowMcmButton(true);
        }
    }, [historyProps]);

    const removeField = (fieldToBeRemoved) => {
        const fieldsCopy = fields.filter(field => {return field !== fieldToBeRemoved;})
        setFields(fieldsCopy);
    }

    const addField = () => {
        const newField = {name: fieldName, type: fieldType};
        const fieldsCopy = Array.from(fields);
        fieldsCopy.push(newField);
        setFields(fieldsCopy);
    }

    const createConfig = () => {
        setAlert(warningAlert);
        const params = {
            AWSAppConfiguration: {
                featureId: historyProps.featureId,
                configurationId: historyProps.configId,
                accountID: accountID,
                template: awsAppConfigTemplate,
                applicationName: applicationName,
                environmentName: environmentName,
                configurationProfile: configurationProfile,
                awsRegion: awsRegion,
                mcmId: historyProps.mcmId,
                fields: fields
            }
        };
        (async () => {
            const headers = await getHeadersForNFMS("CreateAWSAppConfiguration");
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    return (
        <div className="App" data-testid="app">
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <BreadcrumbGroup>
                        <Breadcrumb href={`#${CREATE_FEATURES_BASE_ROUTE}`}>
                            <FormattedMessage id="createConfig.heading" defaultMessage="Create New Configuration"/>
                        </Breadcrumb>
                        <Breadcrumb href={"#"}>
                            <FormattedMessage id="awsAppConfig.heading" defaultMessage="Create New AWS App Configuration"/>
                        </Breadcrumb>
                    </BreadcrumbGroup>
                </Column>
            </Row>
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="medium none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.template" defaultMessage="Template"/>
                    </Text>
                    <Select value={awsAppConfigTemplate} onChange={setAwsAppConfigTemplate}
                            placeholder="Select Template" width={400}>
                        {awsAppConfigTemplates.map(template => (
                            <SelectOption label={template} value={template} key={template} />
                        ))}
                    </Select>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.accountID" defaultMessage="AWS App Config AccountID"/>
                    </Text>
                    <Input id="accountID" value={accountID} width={400}
                           onChange={setAccountID} type="text" placeholder="Enter AWS App Config Account ID"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.applicationName" defaultMessage="Application Name"/>
                    </Text>
                    <Input id="applicationName" value={applicationName} width={400}
                           onChange={setApplicationName} type="text" placeholder="Enter Application name" />
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.environmentName" defaultMessage="Environment Name"/>
                    </Text>
                    <Input id="environmentName" value={environmentName} width={400}
                           onChange={setEnvironmentName} type="text" placeholder="Enter Environment Name"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.configurationProfile" defaultMessage="Configuration Profile"/>
                    </Text>
                    <Input id="configurationProfile" value={configurationProfile} width={400}
                           onChange={setConfigurationProfile} type="text" placeholder="Enter Configuration Profile"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.awsRegion" defaultMessage="AWS Region"/>
                    </Text>
                    <Input id="awsRegion" value={awsRegion} width={400}
                           onChange={setAwsRegion} type="text" placeholder="Enter AWS Region (Eg. us-east-1)"/>
                </Column>
            </Row>

            {showMcmButton ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="awsAppConfig.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={historyProps.mcmId}
                               onChange={id => setHistoryProps({...historyProps, mcmId: id})}
                               type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>
                : null}

            <Row alignmentVertical="top" spacingInset="large large small none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.fieldName" defaultMessage="Field Name"/>
                    </Text>
                    <Input id="field-name" value={fieldName} width={150}
                           onChange={setFieldName} type="text" placeholder="Field Name"/>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.fieldType" defaultMessage="Field Type"/>
                    </Text>
                    <Select  value={fieldType} onChange={setFieldType} placeholder="Field Type" width={130} >
                        {Object.entries(AWS_APP_CONFIG_FIELD_TYPES).map(([key, value]) => (
                            <SelectOption label={key} value={value} key={key} />
                        ))}
                    </Select>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="awsAppConfig.addButton" defaultMessage="."/>
                    </Text>
                    <Button type="secondary" onClick={() => addField()} data-testid="add-button">
                        <FormattedMessage id="awsAppConfig.addButton" defaultMessage="Add Field"/>
                    </Button>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="small small small none" wrap="down">
                {fields.map(field => (
                    <Tag type="neutral" key={field.name} onClose={() => removeField(field)} >
                        {field.name + " (" + field.type + ")"}
                    </Tag>
                ))}
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="xlarge large large none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Button onClick={createConfig} data-testid="create-config">
                        <FormattedMessage id="awsAppConfig.create" defaultMessage="Create Config"/>
                    </Button>
                </Column>
            </Row>
            <Row alignmentVertical="top" spacingInset="none none medium none">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>
        </div>
    );
}

export default injectIntl(AWSAppConfiguration);


// WEBPACK FOOTER //
// ./src/components/create-config/AWSAppConfiguration.js